// @ts-check

import React, { Component } from "react"
import { Link } from "react-router"
import { multiline } from "../../attributes/items/primitives"
import { Text } from "ui"
import ContentEditable from "react-sane-contenteditable"

/**
 * @augments {Component<BlockTypeProps<{text: string}>, any>}
 */
export default class HTMLBlockType extends Component {

    componentDidMount() {
        if (this.props.config.attributes["script"]) {
            const script = document.createElement("script");
            script.async = true;
            script.text = this.props.config.attributes["script"];
            document.body.appendChild(script);
        }
    }
    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle }) => {
                    return (
                        <div
                            style={computedStyle}
                            dangerouslySetInnerHTML={{ __html: attrs.html }}
                        />
                    )
                }}
            </Wrapper>
        )
    }
}

HTMLBlockType.attributes = [multiline({ field: "html", label: "HTML" }), multiline({ field: "script", label: "JavaScript" })]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/other/HtmlBlock.js